import React, { useState, useEffect } from "react";
import { Box, TextField, Button, Typography, Alert, FormControl, Select, MenuItem, Chip } from "@mui/material";
import MjLabel from "../../../components/ui/MjLabel";
import MjErrorText from "../../../components/ui/MjErrorText";
import { Formik, Form, Field, ErrorMessage } from "formik";
import * as Yup from "yup";
import { useAuthContext } from "../../../hooks/useAuthContext";
import Api from "../../../api/Api";
import { Urls } from "../../../api/Urls";
import { useLocation, useParams } from "react-router-dom";

import EpiDetails from "./EpiDetails";
import InterimaireDetails from "../details-Interimaire/InterimaireDetails";
import EntrepriseDetails from "../detailEntreprise/EntrepriseDetails";
import DetailContrat from "../detail-contrat/DetailContrat";

function ContentSelectorEpi() {
  const params = useParams();
  // console.log("PARAMS = ", params);
  const location = useLocation();
  // console.log("LOCATION = ", location);
  const { user } = useAuthContext();
  const access_token = user?.access_token;
  const [succes, setSuccess] = useState("");
  const [error, setError] = useState("");
  const [agencies, setAgencies] = useState([]);
  const [selectedAgency, setSelectedAgency] = useState(null);
  const [searchedAgency, setSearchedAgency] = useState("");
  const [roles, setRoles] = useState([]);
  const [selectedRole, setSelectedRole] = useState(null);
  const [searchedRole, setSearchedRole] = useState("");

  const [epi, setEpi] = useState({});

  const [selectedTab, setSelectedTab] = useState(1);

  const [change, setChange] = useState(0);

  const tabs = [
    {
      id: 1,
      name: "Demande d'EPI",
      icon: "",
    },
    {
      id: 2,
      name: "Interimaire",
      icon: "",
    },
    {
      id: 3,
      name: "Entreprise",
      icon: "",
    },
    {
      id: 4,
      name: "Contrat",
      icon: "",
    },
  ];

  // //get epi
  useEffect(() => {
    Api.get("/admin/epis" + `/${params?.id}`, {
      headers: { "content-type": "application/json", authorization: `Bearer ${access_token}` },
    })
      .then((res) => {
        setEpi(res?.data?.epi);
        console.log("epi ::::::", res.data.epi);
      })
      .catch((err) => {
        console.log(err);
      });
  }, [change]);

  const chipSelector = (status) => {
    switch (status) {
      case "ACCEPTED":
        return <Chip variant="ended_offer" label={"Accepté"} />;
      case "REFUSED":
        return <Chip variant="rejected_offer" label={"Refusé"} />;
      case "PENDING":
        return <Chip variant="active_offer" label={"En attente"} />;
    }
  };

  const contentSelector = (contentId = 1) => {
    switch (contentId) {
      case 1:
        return <EpiDetails change={change} setChange={setChange} />;
      case 2:
        return <InterimaireDetails modify={false} idInterimaire={epi.interim_id} />;
      case 3:
        return <EntrepriseDetails modify={false} idEntreprise={epi.enterprise_id} />;
      case 4:
        return <DetailContrat modify={false} id={epi.contract_id} />;
      default:
        return <div>contrat</div>;
    }
  };

  return (
    <Box>
      {/* Header Section */}
      <Box className="header" sx={{ marginBottom: "1rem" }}>
        <Typography variant="h4" component="h1" fontWeight="600" mb>
          Gestion des Epis
        </Typography>

        <Box display="flex" flexDirection="row" alignItems="center" gap="10px">
          <Typography variant="h5" component="h1" fontWeight="600">
            {"CONTRAT ID: " + epi.contract_id}
          </Typography>
          <>{chipSelector(epi.status)}</>
        </Box>
      </Box>

      {/* tabs */}
      <Box display="flex" sx={{ maxWidth: "700px", backgroundColor: "#FAFAFB", borderRadius: "6px", padding: "2px", flexDirection: { md: "row", xs: "column" } }} gap="6px" margin="40px 0px">
        {tabs.map((tab, index) => (
          <Button disableRipple fullWidth key={index} variant={selectedTab === tab.id ? "mj_primary_choice_active_lg" : "mj_primary_choice_lg"} onClick={() => setSelectedTab(tab.id)}>
            <Typography fontSize="20px" mr>
              {tab.icon}
            </Typography>
            {tab.name}
          </Button>
        ))}
      </Box>

      {/* content */}
      {contentSelector(selectedTab)}
    </Box>
  );
}

export default ContentSelectorEpi;
